import React from 'react';
import { ApsListFilter } from '../../detail/doctorInfo/filterDoctors';

export type ListView = ApsListFilter | 'Others';

interface FilterTabsProps {
  active: ListView;
  onChange: (next: ListView) => void;
}

const TABS: { value: ListView; label: string; dot?: boolean }[] = [
  { value: 'All', label: 'All' },
  { value: 'Disclosure', label: 'Disclosures' },
  { value: 'Dx', label: 'DX' },
  { value: 'Rx', label: 'Rx' },
  { value: 'PreviouslyOrdered', label: 'Previously Ordered' },
  { value: 'Others', label: 'Others', dot: true },
];

const FilterTabs = ({ active, onChange }: FilterTabsProps) => (
  <div className="filter-tabs" role="tablist">
    {TABS.map(tab => (
      <button
        key={tab.value}
        type="button"
        role="tab"
        aria-selected={active === tab.value}
        className={`filter-tab ${active === tab.value ? 'active' : ''}`}
        onClick={() => onChange(tab.value)}
      >
        {tab.dot && <span className="google-dot" />}
        {tab.label}
      </button>
    ))}
  </div>
);

export default FilterTabs;
